export const types = {
  Section: {
    type: 'Section',
    color: 'var(--color-viz-cat-2-primary)',
    isContent: false,
  },
  Row: {
    type: 'Row',
    color: 'var(--color-viz-cat-3-primary)',
    isContent: false,
  },
  Cell: {
    type: 'Cell',
    color: 'var(--color-viz-cat-1-primary)',
    isContent: false,
  },
  Content: {
    type: 'Content',
    color: 'var(--color-viz-cat-1-primary)',
    isContent: true,
  },
  CustomField: {
    type: 'CustomField',
    color: 'var(--color-viz-cat-1-primary)',
    isContent: true,
  },
  Attachments: {
    type: 'Attachments',
    color: 'var(--color-viz-cat-1-primary)',
    isContent: true,
  },
  FormField: {
    type: 'FormField',
    color: 'var(--color-viz-cat-1-primary)',
    isContent: true,
  },
  Button: {
    type: 'Button',
    color: 'var(--color-viz-cat-1-primary)',
    isContent: true,
  },
  HTMLBlock: {
    type: 'HTMLBlock',
    color: 'var(--color-viz-cat-1-primary)',
    isContent: true,
    group: 'advanced',
  },
  Text: {
    type: 'Text',
    color: 'var(--color-viz-cat-1-primary)',
    isContent: true,
  },
  Image: {
    type: 'Image',
    color: 'var(--color-viz-cat-1-primary)',
    isContent: true,
  },
  Divider: {
    type: 'Divider',
    color: 'var(--color-viz-cat-1-primary)',
    isContent: true,
  },
  Unknown: {
    type: 'Unknown',
    color: 'var(--color-background-darker)',
    isContent: false,
  },
} as const;

export type NodeType = keyof typeof types;

export const getTypeInfo = (type: NodeType | undefined) => {
  if (!type) {
    return null;
  }
  return types[type] || types.Unknown;
};
